function h() {
  return typeof window > "u" && typeof self < "u";
}
function L(t) {
  const o = [];
  return function s(n, r = "") {
    Object.keys(n).forEach((e) => {
      const c = r ? `${r}.${e}` : e;
      n[e] === Object(n[e]) && s(n[e], c), typeof n[e] == "function" && o.push(c);
    });
  }(t), o;
}
const N = /^(https?:|file:)?\/\/([^/:]+)?(:(\d+))?/, O = { "http:": "80", "https:": "443" };
function C(t) {
  const { location: o } = document, s = N.exec(t || "");
  let n, r, e;
  if (s ? [, n = o.protocol, r, , e] = s : (n = o.protocol, r = o.hostname, e = o.port), n === "file:")
    return "null";
  const c = e && e !== O[n] ? `:${e}` : "";
  return `${n}//${r}${c}`;
}
function I(t, o, s) {
  const n = Array.isArray(o) ? o : o.split(".").filter(Boolean);
  let r = t;
  for (const e of n)
    if (r = r == null ? void 0 : r[e], r === void 0)
      return s;
  return r;
}
function _(t, o, s) {
  if (!t || typeof t != "object") return t;
  const n = Array.isArray(o) ? o : o.split(".").map((e) => e.match(/^\d+$/) ? Number(e) : e);
  let r = t;
  for (let e = 0; e < n.length; e++) {
    const c = n[e];
    e === n.length - 1 ? r[c] = s : ((!r[c] || typeof r[c] != "object") && (r[c] = typeof n[e + 1] == "number" ? [] : {}), r = r[c]);
  }
  return t;
}
function m(t = 10) {
  const o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let s = "";
  for (let n = 0; n < t; n++)
    s += o.charAt(Math.floor(Math.random() * o.length));
  return s;
}
var f = /* @__PURE__ */ ((t) => (t.MESSAGE = "message", t))(f || {}), l = /* @__PURE__ */ ((t) => (t.HANDSHAKE_REQUEST = "RIMLESS/HANDSHAKE_REQUEST", t.HANDSHAKE_REPLY = "RIMLESS/HANDSHAKE_REPLY", t.RPC_REQUEST = "RIMLESS/RPC_REQUEST", t.RPC_RESOLVE = "RIMLESS/RPC_RESOLVE", t.RPC_REJECT = "RIMLESS/RPC_REJECT", t))(l || {});
function y(t = {}, o = [], s, n) {
  const r = [];
  return o.forEach((e) => {
    async function c(a) {
      const { action: i, callID: u, connectionID: S, callName: d, args: p = [] } = a.data;
      if (i !== l.RPC_REQUEST || !u || !d || d !== e || S !== s) return;
      const E = {
        action: l.RPC_RESOLVE,
        callID: u,
        callName: d,
        connectionID: S,
        error: null,
        result: null
      };
      try {
        const R = await I(t, e)(...p);
        E.result = JSON.parse(JSON.stringify(R));
      } catch (R) {
        E.action = l.RPC_REJECT, E.error = JSON.parse(JSON.stringify(R, Object.getOwnPropertyNames(R)));
      }
      n ? n.postMessage(E) : h() ? self.postMessage(E) : a.source.postMessage(E, a.origin);
    }
    n ? n.addEventListener(f.MESSAGE, c) : self.addEventListener(f.MESSAGE, c), r.push(() => self.removeEventListener(f.MESSAGE, c));
  }), () => r.forEach((e) => e());
}
function w(t, o, s, n = [], r) {
  return (...e) => new Promise((c, a) => {
    const i = m();
    function u(d) {
      const { callID: p, connectionID: E, callName: R, result: A, error: D, action: g } = d.data;
      if (!(!p || !R) && R === t && E === o) {
        if (g === l.RPC_RESOLVE) return c(A);
        if (g === l.RPC_REJECT) return a(D);
      }
    }
    const S = {
      action: l.RPC_REQUEST,
      args: JSON.parse(JSON.stringify(e)),
      callID: i,
      callName: t,
      connectionID: o
    };
    r ? r.addEventListener(f.MESSAGE, u) : self.addEventListener(f.MESSAGE, u), n.push(() => self.removeEventListener(f.MESSAGE, u)), r ? r.postMessage(S) : h() ? self.postMessage(S) : (s.source || s.target).postMessage(S, s.origin);
  });
}
function P(t = {}, o = [], s, n, r) {
  const e = { ...t }, c = [];
  return o.forEach((a) => {
    const i = w(a, s, n, c, r);
    _(e, a, i);
  }), {
    remote: e,
    unregisterRemote: () => c.forEach((a) => a())
  };
}
function H(t = {}, o) {
  return new Promise((s) => {
    const n = L(t);
    async function r(c) {
      var E;
      if (c.data.action !== l.HANDSHAKE_REPLY) return;
      const a = y(t, n, c.data.connectionID), { remote: i, unregisterRemote: u } = P(
        c.data.schema,
        c.data.methods,
        c.data.connectionID,
        c
      );
      await ((E = o == null ? void 0 : o.onConnectionSetup) == null ? void 0 : E.call(o, i));
      const S = {
        action: l.HANDSHAKE_REPLY,
        connectionID: c.data.connectionID
      };
      return h() ? self.postMessage(S) : window.parent.postMessage(S, "*"), s({ remote: i, close: () => {
        self.removeEventListener(f.MESSAGE, r), u(), a();
      } });
    }
    self.addEventListener(f.MESSAGE, r);
    const e = {
      action: l.HANDSHAKE_REQUEST,
      methods: n,
      schema: JSON.parse(JSON.stringify(t))
    };
    h() ? self.postMessage(e) : window.parent.postMessage(e, "*");
  });
}
const G = {
  connect: H
}, M = {};
function J(t, o) {
  const s = t.getAttribute("src"), n = C(s), r = o.origin === n, e = o.source === t.contentWindow;
  return r && e;
}
function T(t, o = {}) {
  if (!t) throw new Error("a target is required");
  const s = t.onerror !== void 0 && t.onmessage !== void 0, n = s ? t : window;
  return new Promise((r) => {
    const e = m();
    function c(i) {
      if (!s && !J(t, i) || i.data.action !== l.HANDSHAKE_REQUEST) return;
      const u = L(o), S = y(
        o,
        u,
        e,
        s ? t : void 0
      ), { remote: d, unregisterRemote: p } = P(
        i.data.schema,
        i.data.methods,
        e,
        i,
        s ? t : void 0
      ), E = {
        action: l.HANDSHAKE_REPLY,
        connectionID: e,
        methods: u,
        schema: JSON.parse(JSON.stringify(o))
      };
      s ? t.postMessage(E) : i.source.postMessage(E, i.origin);
      const A = { remote: d, close: () => {
        n.removeEventListener(f.MESSAGE, c), p(), S(), s && t.terminate();
      } };
      M[e] = A;
    }
    n.addEventListener(f.MESSAGE, c);
    function a(i) {
      if (i.data.action === l.HANDSHAKE_REPLY)
        return r(M[i.data.connectionID]);
    }
    n.addEventListener(f.MESSAGE, a);
  });
}
const K = {
  connect: T
};
export {
  l as actions,
  f as events,
  G as guest,
  K as host
};
//# sourceMappingURL=rimless.js.map
